module.exports = __webpack_public_path__ + "db0bc371c0e7bd18549aae31431612c8.svg";